import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

export const useHeroRevealAnimation = (ref: React.RefObject<HTMLDivElement | null>) => {
  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);

      const { current } = ref;
      if (!current) return;

      gsap.set(current, { yPercent: -100 });
      const end = current.offsetHeight;
      const animation = gsap.timeline({ paused: true });

      animation.to(current, {
        yPercent: 0,
        ease: 'none',
        duration: 1,
      });

      ScrollTrigger.create({
        trigger: current,
        start: 'bottom bottom',
        end: `+=${end} bottom`,
        scrub: true,
        animation: animation,
      });
    },
    { scope: ref },
  );
};
